module.exports = __webpack_public_path__ + "static/media/404.64be47a3.svg";